type PhotoType = {
  url?: string;
  fullpath?: string;
  thumbnails?: {
    [key: string]: {
      url?: string;
      fullpath?: string;
    };
  };
};

export const getThumbnailUrl = (
  photo: PhotoType | null | undefined,
  thumbnail: string | null = null
): string | null => {
  if (!photo) {
    return null;
  }

  if (!thumbnail) {
    return photo?.url || null;
  }

  return photo?.thumbnails?.[thumbnail]?.url || photo?.url || null;
};

